import React, { PureComponent } from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import * as alert from '../../../../common/services/alert';
import Modal from '../../../../common/components/modal';
import { Button } from '../../../../common/components/button';
import Icon from '../../../../common/components/icon';
import * as Form from '../../../../common/components/form';
import bulkUpdateUsers from '../../actions/bulk-update-function-users';

const { Label, UsersInput } = Form;

class FunctionForm extends PureComponent {
  static propTypes = {
    organisation: PropTypes.object.isRequired,
    network: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    function: PropTypes.object,
    children: PropTypes.any,
    onClose: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.handleExit = this.handleExit.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.setReference = (ref) => (this.modal = ref);
  }

  createHeader() {
    const { function: item, organisation, t } = this.props;

    if (item && item.external_id && organisation?.integrations?.length) {
      return (
        <div className="SyncMessage">
          <Icon type="sync_alt" />
          <Trans
            i18nKey="network:forms_function_header_synchronized"
            values={{ integrationName: t('organisation:integration_label') }} components={[<b>a</b>]}
          />
        </div>
      );
    }

    return <Modal.Title>{item ? t('network:forms_function_header_change') : t('network:forms_function_header_create')}</Modal.Title>;
  }

  handleExit() {
    this.props.reset();
    if (this.props.onClose) this.props.onClose();
  }

  async handleSubmit(values, dispatch) {
    const { function: item, t } = this.props;
    try {
      await dispatch(bulkUpdateUsers(item.id, values.users));
      alert.success(t('network:forms_function_success'));
      this.handleExit();
    } catch (response) {
      alert.forStatus(response.status_code, {
        warning: t('network:forms_function_warning'),
        error: t('network:forms_function_error'),
      });
    }
  }

  render() {
    const {
      network, function: item, handleSubmit, submitting, invalid, t,
    } = this.props;

    return (
      <Modal
        ref={this.setReference}
        size="small"
        onExited={this.handleExit}
        header={this.createHeader()}
        content={(
          <>
            <Label text={t('network:forms_function_modal_input')} />
            <UsersInput
              network={network}
              name="users"
              disabled={item && item.external_id}
              organisation={this.props.organisation}
              defaultValue={item.users}
            />
          </>
        )}
        footer={(
          <Button
            type="primary"
            isLoading={submitting}
            buttonType="submit"
            disabled={item && item.external_id || invalid}
          >
            <Trans i18nKey="network:forms_function_modal_button" />
          </Button>
        )}
        wrapper={Modal.FormWrapper}
        wrapperProps={{
          onSubmit: handleSubmit(this.handleSubmit),
        }}
      >
        {this.props.children}
      </Modal>
    );
  }
}

export default withTranslation()(reduxForm({
  initialValues: {
    users: { add: [], remove: [] },
  },
  // validate,
})(FunctionForm));
